var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select-option-group',_vm._b({scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}],null,true)},'a-select-option-group',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }